import { createCollection, localOnlyCollectionOptions } from "@tanstack/react-db";
import { SmartContextRow } from "@/domains/tanstack-db/repositories/smart-contexts/schemas";
import { SMART_CONTEXTS_COLLECTION_ID } from "./constants";

export interface SmartContextLocalCollectionOptions {
  initialData?: Array<SmartContextRow>;
}

export const createSmartContextLocalCollection = (
  options: SmartContextLocalCollectionOptions = {}
) =>
  createCollection(
    localOnlyCollectionOptions<SmartContextRow, string>({
      id: SMART_CONTEXTS_COLLECTION_ID,
      getKey: context => context.id,
      initialData: options.initialData,
    })
  );
